import {
  PARTNER_ID_ADURO_ADVISORS,
  SPEND_BASIC_ADURO_ADVISORS_MINIMUM_USER_COUNT,
  SPEND_BASIC_EIGHT_DOLLARS_MINIMUM_USER_COUNT,
  SPEND_PLUS_ADURO_ADVISORS_MINIMUM_USER_COUNT,
  SPEND_PLUS_TWELVE_DOLLARS_MINIMUM_USER_COUNT
} from '.';
import { AbacusCurrency } from '../helpers';

export const getMinimumUsersForCompany = (partnerId: string | undefined, billingPlanTier: 'basic' | 'plus') => {
  let minimumUserCount =
    billingPlanTier === 'basic' ? SPEND_BASIC_EIGHT_DOLLARS_MINIMUM_USER_COUNT : SPEND_PLUS_TWELVE_DOLLARS_MINIMUM_USER_COUNT;
  let perUserPrice = billingPlanTier === 'basic' ? 8 : 12;

  if (partnerId && partnerId === PARTNER_ID_ADURO_ADVISORS) {
    minimumUserCount =
      billingPlanTier === 'basic' ? SPEND_BASIC_ADURO_ADVISORS_MINIMUM_USER_COUNT : SPEND_PLUS_ADURO_ADVISORS_MINIMUM_USER_COUNT;
  }

  return { minimumUserCount, monthlyTotal: new AbacusCurrency(minimumUserCount * perUserPrice, 'USD', true).toFormattedString(true) };
};
